export default __webpack_public_path__ + "static/media/cloud.bc80da64.webp";